"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-caption-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M4 18h20v2H4zM4 22h16v2H4z" }),
            _react2.default.createElement("path", { fill: "#BBB", d: "M0 14h28v1H0z" }),
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-caption-on.js
// module id = 1877
// module chunks = 0